<p *ngIf="!hasExistingDiscount">
  This membership does not currently have a recurring discount.
</p>

<p *ngIf="hasExistingDiscount">
  This membership currently has a {{ orgConfigService.formatCurrency(membership.recurring_discount_amount) }} recurring discount ({{ membership.recurring_discount_name ? membership.recurring_discount_name : membership.recurring_discount_code }}).
</p>

<div class="form-group" *ngIf="hasExistingDiscount">
  <div class="form-check">
    <input class="form-check-input" type="radio"
           name="removeDiscountFalse" id="removeDiscountFalse"
           [(ngModel)]="removeDiscount" [value]="false">
    <label class="form-check-label" for="removeDiscountFalse">
      Edit Discount
    </label>
  </div>
  <div class="form-check">
    <input class="form-check-input" type="radio"
           name="removeDiscountTrue" id="removeDiscountTrue"
           [(ngModel)]="removeDiscount" [value]="true">
    <label class="form-check-label" for="removeDiscountTrue">
      Remove Discount
    </label>
  </div>
</div>

<ng-container *ngIf="!removeDiscount">

  <div class="form-group">
    <div class="row">
      <div class="col-lg-6 col-md-8">
        <label for="discountTypeSelect">Discount Value</label>
        <select id="discountTypeSelect" name="discountType"
                class="custom-select"
                [(ngModel)]="discountType">
          <option [ngValue]="MembershipDiscountType.currency">Flat Discount</option>
          <option [ngValue]="MembershipDiscountType.percentage">Percentage</option>
        </select>
      </div>
    </div>
  </div>

  <div class="form-group">
    <label for="discountAmountInput">Discount Amount</label>
    <div class="input-group">
      <div class="input-group-prepend" *ngIf="discountType === MembershipDiscountType.currency">
        <span class="input-group-text">{{ orgConfigService.getCurrencySymbol() }}</span>
      </div>
      <input class="form-control" type="number"
             min="0"
             [max]="discountType === MembershipDiscountType.currency ? '' : '100'"
             [step]="discountType === MembershipDiscountType.currency ? '0.01' : '1'"
             required
             id="discountAmountInput"
             name="discountAmount"
             [(ngModel)]="discountAmount">
      <div class="input-group-append" *ngIf="discountType === MembershipDiscountType.percentage">
        <span class="input-group-text">%</span>
      </div>
    </div>
  </div>

  <div class="form-group" *ngIf="discountType === MembershipDiscountType.percentage">
    <label for="appliesToAddOnsSelect">Does this discount apply to add-ons?</label>
    <div class="row">
      <div class="col-lg-6 col-md-8">
        <select class="custom-select" id="appliesToAddOnsSelect" name="discountAppliesToAddOns"
                [(ngModel)]="discountAppliesToAddOns">
          <option [ngValue]="false">No</option>
          <option [ngValue]="true">Yes</option>
        </select>
      </div>
    </div>
    <small class="form-text text-muted">
      If "Yes", this discount will be applied to add-ons, in addition to the base fee.
    </small>
  </div>

  <div class="form-group">
    <label for="discountNameInput">Discount Name</label>
    <input class="form-control" type="text" required
           id="discountNameInput" name="discountName" [(ngModel)]="discountName">
  </div>

  <div class="form-group">
    <label for="grantingAssociationSelect">Granting Association</label>
    <div class="row">
      <div class="col-lg-6 col-md-8">
        <select class="custom-select"
                *ngIf="loadingAssociations">
          <option selected disabled>Loading associations...</option>
        </select>
        <select class="custom-select" id="grantingAssociationSelect" name="discountAssociationId"
                *ngIf="!loadingAssociations"
                [(ngModel)]="discountAssociationId">
          <option [ngValue]="null" class="text-muted">None</option>
          <option *ngFor="let association of commonAssociations"
                  [ngValue]="association.id">
            {{ association.name }}
          </option>
        </select>
      </div>
    </div>
    <small class="form-text text-muted">
      <ng-container *ngIf="membership.all_customers.length === 1">
        If the membership discount has a granting association, then the discount will be automatically removed if the membership's member is removed from the association.
        <br>
        Only associations to which the member belongs may be selected.
      </ng-container>
      <ng-container *ngIf="membership.all_customers.length > 1">
        If the membership discount has a granting association, then the discount will be automatically removed if any of the membership's members are removed from the association.
        <br>
        Only associations to which all members belong may be selected.
      </ng-container>
    </small>
  </div>

  <div class="form-group">
    <label for="grantingMembershipSelect">Granting Membership</label>
    <div class="row">
      <div class="col-lg-6 col-md-8">
        <select class="custom-select"
                *ngIf="loadingMemberships">
          <option selected disabled>Loading memberships...</option>
        </select>
        <select class="custom-select" id="grantingMembershipSelect" name="discountMembershipId"
                *ngIf="!loadingMemberships"
                [(ngModel)]="discountMembershipId">
          <option [ngValue]="null" class="text-muted">None</option>
          <option *ngFor="let membership of commonMemberships"
                  [ngValue]="membership.id">
            {{ membership.name }}
          </option>
        </select>
      </div>
    </div>
    <small class="form-text text-muted">
      <ng-container *ngIf="membership.all_customers.length === 1">
        If the membership discount has a granting membership, then the discount will be automatically removed if the granting membership becomes inactive for the member.
        <br>
        Only memberships to which the member belongs may be selected.
      </ng-container>
      <ng-container *ngIf="membership.all_customers.length > 1">
        If the membership discount has a granting membership, then the discount will be automatically removed if the granting membership becomes inactive for any of the membership's members.
        <br>
        Only memberships to which all members belong may be selected.
      </ng-container>
    </small>
  </div>

</ng-container>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
